import script from "./OrdersBulkUploader.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdersBulkUploader.vue?vue&type=script&setup=true&lang=js"

import "./OrdersBulkUploader.vue?vue&type=style&index=0&id=7505f8c7&lang=css"

const __exports__ = script;

export default __exports__